import React from 'react';

export default function ChevronBottom({ size = 20, color = 'white', className = '', opacity = '0.5', ...props }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15 12.5L10 7.5L5 12.5" stroke={color} strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
      <path
        d="M15 12.5L10 7.5L5 12.5"
        stroke="black"
        strokeOpacity={(Number(opacity) - 1) * -1}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
